
<template>
    <div class="container">
        <div class="lucky-wheel">
            <div class="lucky-title"></div>
            <div class="wheel-main">
                <div class="wheel-pointer-box">
                     <div class="wheel-pointer" @click="rotate_handle()" :style="{transform:rotate_angle_pointer,transition:rotate_transition_pointer}"></div>
                </div>
                <div class="wheel-bg" :style="{transform:rotate_angle,transition:rotate_transition}">
                    <div class="prize-list">
                        <div class="prize-item" v-for="(item,index) in prize_list" :key="index">
                            <div class="prize-pic">
                                <img :src="item.icon">
                            </div>
                            <div class="prize-count" v-if="item.count">
                                {{item.count}}
                            </div>
                            <div class="prize-type">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="main-bg"></div>
            <div class="bg-p"></div>
            <div class="content">
                <div class="lottery_ticket">今日免费抽奖次数： {{ lottery_ticket}}</div>
            </div>
            <div class="tip">
                <div class="tip-title">活动规则</div>
                <div class="tip-content">
                   
                    <p> 1.每日签到后，即可获得一次幸运大转盘的机会，仅限当天有效，过期作废。 </p>
                   
                    <p> 2.果实可以用来兑换积分商城中的商品</p>
                    <p>3、优惠券可用来（链接指定坚果官方店铺）购买商品</p>
                    <p>如有疑问请加微信：jmgoxr（ 备注：论坛转盘）</p>
                </div>
            </div>
        </div>
        <div class="toast" v-show="toast_control">
            <div class="toast-container">
                <img :src="toast_pictrue" class="toast-picture">
                <div class="close" @click="close_toast()"></div>
                <div class="toast-title" v-html="toast_title">
                    
                </div>
                <div class="toast-btn">
                    <div class="toast-cancel"  @click="confirm_toast()" v-if="prize_type==1">确认领取</div>
                    <div class="toast-cancel copyBtn" :data-clipboard-text ="str_href"  @click="copy_toast()" v-if="prize_type==2">复制链接</div>
                </div>
            </div>
        </div>
        <div class="toast-mask" v-show="toast_control"></div>
    </div>
</template>
<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import Qs from 'qs'
import { Toast } from 'vant';
import Clipboard from 'clipboard';
let clipboard = new Clipboard('.copyBtn');
Vue.use(Toast);
export default {
  data() {
    return {
      easejoy_bean: 0, //果实
      fruits:0,
      data:{},
      lottery_ticket: 1, //抽奖次数
      prize_list: [
        {
          prize_id:1,
          game_code:'',
          icon: require("./img/point_five.png"),
          count: 50,
          name: "优惠券",
          isPrize: 1,
          prize_type:2,
          min_num:0,
          max_num:1250,
          str_href:'https://taoquan.taobao.com/coupon/unify_apply.htm?sellerId=2587461980&activityId=fe78165ae174463497f7cc6bc953b3ab',
        },
        {
          prize_id:2,
          game_code:'',
          icon: require("./img/point_five.png"),
          count: 100,
          name: "优惠券",
          isPrize: 1,
          prize_type:2,
          min_num:1251,
          max_num:2500,
          str_href:'https://taoquan.taobao.com/coupon/unify_apply.htm?sellerId=2587461980&activityId=5a743353e98c468aa25f24365afe5201',
        },
        {
          prize_id:3,
          game_code:'',
         icon: require("./img/point_five.png"),
          count: 150,
          name: "优惠券",
          isPrize: 1,
          prize_type:2,
          min_num:2501,
          max_num:3750,
          str_href:'https://taoquan.taobao.com/coupon/unify_apply.htm?sellerId=2587461980&activityId=40c9cfcce323442c9b0069e5c3e6606e',
        },
        {
          prize_id:4,
          game_code:'',
          icon: require("./img/bean_500.png"),
          count: 50,
          name: "果实",
          isPrize: 1,
          prize_type:1,
          min_num:3751,
          max_num:5000,
          str_href:'',
        },
        {
          prize_id:5,
          game_code:'',
          icon: require("./img/point_five.png"),
          count: 50,
          name: "优惠券",
          isPrize: 1,
          prize_type:2,
          min_num:0,
          max_num:1250,
          str_href:'https://taoquan.taobao.com/coupon/unify_apply.htm?sellerId=2587461980&activityId=fe78165ae174463497f7cc6bc953b3ab',
        },
        {
          prize_id:6,
          game_code:'',
          icon: require("./img/point_five.png"),
          count: 100,
          name: "优惠券",
          isPrize: 1,
          prize_type:2,
          min_num:1251,
          max_num:2500,
          str_href:'https://taoquan.taobao.com/coupon/unify_apply.htm?sellerId=2587461980&activityId=5a743353e98c468aa25f24365afe5201',
        },
        {
          prize_id:7,
          game_code:'',
         icon: require("./img/point_five.png"),
          count: 150,
          name: "优惠券",
          isPrize: 1,
          prize_type:2,
          min_num:2501,
          max_num:3750,
          str_href:'https://taoquan.taobao.com/coupon/unify_apply.htm?sellerId=2587461980&activityId=40c9cfcce323442c9b0069e5c3e6606e',
        },
        {
          prize_id:8,
          game_code:'',
          icon: require("./img/bean_ten.png"),
          count: 20,
          name: "果实",
          isPrize: 1,
          prize_type:1,
          min_num:3751,
          max_num:5000,
          str_href:'',
        }
      ], //奖品列表
      prize_type:0,//抽奖结果分类 0,未中奖，1，果实 ，2,优惠券
      toast_control: false, //抽奖结果弹出框控制器
      hasPrize: false, //是否中奖
      start_rotating_degree: 0, //初始旋转角度
      rotate_angle: 0, //将要旋转的角度
      start_rotating_degree_pointer: 0, //指针初始旋转角度
      rotate_angle_pointer: 0, //指针将要旋转的度数
      rotate_transition: "transform 6s ease-in-out", //初始化选中的过度属性控制
      rotate_transition_pointer: "transform 12s ease-in-out", //初始化指针过度属性控制
      click_flag: true, //是否可以旋转抽奖
      i: 0, //测试使用
      str_href:'',
      game_code:'',
      prize_id:0,
      prize_name:'',
    };
  },
  created() {
    this.init_prize_list();
  },
  computed: {
    toast_title() {
      let return_str='';
      if(this.hasPrize){
        if(this.prize_type==2){
          return_str='<div style="background:url(/static/product/quan.png) center top no-repeat;width:230px;margin:0 auto;height:85px;"><span style="display:inline-block;color: #fff;font-size: 40px;margin-left: -90px;margin-top: 20px;">'+this.prize_list[this.i].count+'</span></div><span style="font-size:12px;">恭喜您，获得 ' +this.prize_list[this.i].count + ' ' + this.prize_list[this.i].name+'</span><input type="text" style=" margin-top: 10px;width: 90%;margin-bottom: 10px;display: inline-block;height: 30px;line-height: 30px;border-radius: 3px;" class="copy_input" value="'+this.prize_list[this.i].str_href+'"><p style="width:90%;margin:0 auto;font-size:12px;height:25px;line-height:25px;" class="cope_p">点击下方复制按钮复制链接在浏览器打开</p>';
        }else if(this.prize_type==1){
          return_str="恭喜您，获得" +this.prize_list[this.i].count + ' ' + this.prize_list[this.i].name
        }
        
      }else{
        return_str="未中奖";
      }
      return return_str
    },
    toast_pictrue() {
      return this.hasPrize
        ? require("./img/congratulation.png")
        : require("./img/sorry.png");
    }
  },
  methods: {
    //此方法为处理奖品数据
    init_prize_list() {
        utilAxios.get({
        url: '/new_api.php?module=big_wheel&mod=index',
        method: 'GET',
        callback: (res) => {
          if(res.data.code=='100'){
            console.log(res);
            this.lottery_ticket=res.data.lottery_ticket;
            this.formhash=res.data.formhash;
          }else{
            window.location.href="https://www.jmgo.com/mobile/user.php?act=bbslogin&sync=bbs&loginhash=&back_act="+escape('http://bbs.jmgo.com/dist/#/dial')
          }
          

        }
      })
    },
    rotate_handle() {

      let rand_num=Math.ceil(Math.random()*10000);
      let p_index=0;
      this.prize_list.forEach((item,key)=>{
        if(rand_num>=item.min_num && rand_num<=item.max_num){
          p_index=key;
          return;
        }
      })
     
      this.rotating(p_index);
      
    },
    rotating(index) {
      if(this.lottery_ticket<=0){
        this.click_flag=false;
        Toast('你今天的抽奖次数已用完');
        return;
      } 
      if (!this.click_flag) return;
      var type = 0; // 默认为 0  转盘转动 1 箭头和转盘都转动(暂且遗留)
      var during_time = 5; // 默认为1s
      var random = Math.floor(Math.random() * 7);
      var result_index = index || random; // 最终要旋转到哪一块，对应prize_list的下标
      var result_angle = [337.5, 292.5, 247.5, 202.5, 157.5, 112.5, 67.5, 22.5]; //最终会旋转到下标的位置所需要的度数
      this.i=result_index;
      var rand_circle = 3; // 附加多转几圈，2-3
      this.click_flag = false; // 旋转结束前，不允许再次触发
      if (type == 0) {
        // 转动盘子
        var rotate_angle =
          this.start_rotating_degree +
          rand_circle * 360 +
          result_angle[result_index] -
          this.start_rotating_degree % 360;
        this.start_rotating_degree = rotate_angle;
        this.rotate_angle = "rotate(" + rotate_angle + "deg)";
        // // //转动指针
        // this.rotate_angle_pointer = "rotate("+this.start_rotating_degree_pointer + 360*rand_circle+"deg)";
        // this.start_rotating_degree_pointer =360*rand_circle;
        var that = this;
        // 旋转结束后，允许再次触发
        setTimeout(function() {
          that.click_flag = true;
          that.game_over(result_index);
        }, during_time * 1000 + 1500); // 延时，保证转盘转完
      } else {
        //
      }
    },
    game_over(result_index) {
      this.toast_control = true;
      this.lottery_ticket-=1;
      this.fruits=this.prize_list[result_index].count
      this.prize_type=this.prize_list[result_index].prize_type
      this.hasPrize = this.prize_list[result_index].isPrize
      this.str_href=this.prize_list[result_index].str_href
      this.prize_name=this.prize_list[result_index].name
       this.prize_id=this.prize_list[result_index].prize_id
       let params={
        formhash:this.formhash,
        prize_type:this.prize_type,
        prize_name:this.prize_name,
        str_href:this.str_href,
        prize_count:this.fruits,
        is_prize:this.hasPrize,
        prize_id:this.prize_id,
        game_code:this.game_code,
      }
      //const data = Qs.stringify(param)
      utilAxios.formpost({
        url: '/new_api.php?module=big_wheel&mod=post',
        method: 'POST',
        data:Qs.stringify(params),
        callback: (res) => {
          if (res.data.code == 100) {
               //Toast.success(res.data.msg)
                 
             } else {
               Toast.fail(res.data.msg)
             }
        }
      })

    },
    confirm_toast(){

      this.toast_control = false;
    },
    copy_toast(){
      this.confirm_toast()
      this.toast_control = false;
    },
    //关闭弹窗
    close_toast() {
      this.toast_control = false;
    }
  }
};
</script>
<style scoped>
.container {
  width: 100%;
}
.lucky-wheel {
  width: 100%;
  height: 6.3125rem;
  background: rgb(252, 207, 133) url("./img/color_pillar.png") no-repeat
    center bottom;
  background-size: 100%;
  padding-top: 0.3125rem;
}
.lucky-title {
  width: 100%;
  height: 1.625rem;
  background: url("./img/lucky_title.png") no-repeat center top;
  background-size: 100%;
}
.wheel-main {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.wheel-bg {
  width: 3.1rem;
  height: 3.1rem;
  background: url("./img/draw_wheel.png") no-repeat center top;
  background-size: 100%;
  color: #fff;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  transition: transform 3s ease;
}
.wheel-pointer-box {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -60%);
  width: 0.9rem;
  height: 0.9rem;
}
.wheel-pointer {
  width: 0.9rem;
  height: 0.9rem;
  background: url("./img/draw_btn.png") no-repeat center top;
  background-size: 100%;
  transform-origin: center 50%;
}
.wheel-bg div {
  text-align: center;
}
.prize-list {
  width: 100%;
  height: 100%;
  position: relative;
}
.prize-list .prize-item {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.prize-list .prize-item:first-child {
  top: -0.03rem;
  left: 1.2525rem;
  transform: rotate(20deg);
}
.prize-list .prize-item:nth-child(2) {
  top: 0.36rem;
  left: 1.67rem;
  transform: rotate(67deg);
}
.prize-list .prize-item:nth-child(3) {
  top: 0.92rem;
  left: 1.65rem;
  transform: rotate(-250deg);
}
.prize-list .prize-item:nth-child(4) {
  top: 1.35rem;
  left: 1.2525rem;
  transform: rotate(-206deg);
}
.prize-list .prize-item:nth-child(5) {
  top: 1.3465rem;
  left: 0.65rem;
  transform: rotate(-160deg);
}
.prize-list .prize-item:nth-child(6) {
  top: 0.9275rem;
  left: 0.26rem;
  transform: rotate(-115deg);
}
.prize-list .prize-item:nth-child(7) {
  top: .36rem;
  left: 0.29rem;
  transform: rotate(-69deg);
}
.prize-list .prize-item:nth-child(8) {
  top: -0.03rem;
  left: 0.68rem;
  transform: rotate(-20deg);
}
.prize-item {
  width: 1.175rem;
  height: 1.8rem;
}

.prize-pic img {
  width: 0.65rem;
  height: 0.4rem;
  margin-top: 0.3125rem;
}
.prize-count {
  font-size: 0.12rem;
}
.prize-type {
  font-size: 0.12rem;
}
.main {
  position: relative;
  width: 100%;
  min-height: 2.85rem;
  background: rgb(243, 109, 86);
  padding-bottom: 0.3375rem;
}
.main-bg {
  width: 100%;
  height: 1.3125rem;
  position: absolute;
  top: -0.6875rem;
  left: 0;
  background: url("./img/luck_bg.png") no-repeat center top;
  background-size: 100%;
}
.bg-p {
  width: 100%;
  height: 0.59rem;
  background: rgb(252, 207, 133);
}
.content {
  position: absolute;
  top: 0.035rem;
  left: 0;
  background: rgb(243, 109, 86);
  width: 100%;
  height: 1.0375rem;
  font-size: 0.225rem;
  color: #ffeb39;
}
.content div {
  text-align: center;

}
.tip {
  position: relative;
  margin: 0.5rem auto 0;
  width: 3.0rem;
  border: 1px solid #fbc27f;
}
.tip-title {
  position: absolute;
  top: -0.2rem;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 0.2rem;
  color: #fccc6e;
  background: rgb(243, 109, 86);
  padding: 0.0625rem 0.125rem;
}
.tip-content {
  padding: 0.3125rem 0.125rem;
  font-size: 0.175rem;
  color: #fff8c5;
  line-height: 1.5;
}
.toast-mask {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  width: 100%;
  height: 100%;
}
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 20000;
  transform: translate(-50%, -50%);
  width: 2.7rem;
  background: #fff;
  border-radius: 6.25px;
  padding: 6.25px;
  background-color: rgb(252, 244, 224);
}
.toast-container {
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px dotted #fccc6e;
}
.toast-picture {
  position: absolute;
  top: -1.01rem;
  left: -0.3rem;
  width: 3.45rem;
  height: 1.5225rem;
}
.toast-pictrue-change {
  position: absolute;
  top: -0.3rem;
  left: -0.275rem;
  width: 3.5rem;
  height: 0.625rem;
}
.toast-title {
  padding: 0.5625rem 0;
  font-size: 0.18rem;
  color: #fc7939;
  text-align: center;
}
.toast-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.1875rem;
}
.copy_input{
    margin-top: 10px;
    width: 90%;
    margin-bottom: 10px;
    display: inline-block;
    height: 30px;
    line-height: 30px;
    border-radius: 3px;
}
.copy_p{
  width:90%;
  margin:0 auto;
}
.toast-btn div {
  background-image: -moz-linear-gradient(
    -18deg,
    rgb(242, 148, 85) 0%,
    rgb(252, 124, 88) 51%,
    rgb(252, 124, 88) 99%
  );

  background-image: -ms-linear-gradient(
    -18deg,
    rgb(242, 148, 85) 0%,
    rgb(252, 124, 88) 51%,
    rgb(252, 124, 88) 99%
  );
  background-image: -webkit-linear-gradient(
    -18deg,
    rgb(242, 148, 85) 0%,
    rgb(252, 124, 88) 51%,
    rgb(252, 124, 88) 99%
  );
  box-shadow: 0px 0.04rem 0px 0px rgba(174, 34, 5, 0.7);
  width: 0.9375rem;
  height: 0.375rem;
  border-radius: 37.5px;
  text-align: center;
  line-height: 37.5px;
  color: #fff;
}
.close {
  position: absolute;
  top: -0.1875rem;
  right: -0.1875rem;
  width: 0.4rem;
  height: 0.4rem;
  background: url("./img/close_store.png") no-repeat center top;
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dial/Dial.vue